import {Box, Text} from 'exsportia-components'
import React, {FC} from 'react'

import {FieldProps} from './types'

export const SectionField: FC<FieldProps> = ({question, theme}) => {
  const {config} = question
  return (
    <Box pt='12px' borderTop={`1px solid ${theme.colors.border}`}>
      {config?.description && (
        <Text settings={{fontSize: '13px', color: theme.colors.gray}}>{config.description}</Text>
      )}
    </Box>
  )
}
